import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=80434da8&scoped=true"
import script from "./PropertyManagement.vue?vue&type=script&lang=js"
export * from "./PropertyManagement.vue?vue&type=script&lang=js"
import style0 from "./PropertyManagement.vue?vue&type=style&index=0&id=80434da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80434da8",
  null
  
)

export default component.exports